<template>
  <div class="loading-splash">
    <div>
      <img :src="thumbnail" alt="" class="splash-thumb" @contextmenu.prevent @drag.prevent
           @dragstart.prevent>
      <div class="mgt-spinner big rel"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",

  props: {
    thumbnail:{}
  },

  data() {
    return {};
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/spinner';

.loading-splash {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-splash > div {
  max-height: 100%;
}


.splash-thumb {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  filter: blur(10px);
  object-fit: cover;
  opacity: .5;
}

</style>